export default {
  label: {
    id: 'resolution_flow_return_confirmation_page_cta_print_return_label',
    defaultMessage: 'Print return label',
  },
}
